import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'warema-search-instructions',
    templateUrl: './search-instructions.component.html',
    styleUrls: ['./search-instructions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class SearchInstructionsComponent {}
